/**
 * The only file that names `@stripe/stripe-js` (TMMRSL-0015). Memoizes `loadStripe` per
 * `(publishableKey, stripeAccount)` so React StrictMode double-invokes stay safe.
 */
import { loadStripe, type Stripe } from '@stripe/stripe-js';

export type StripeClient = Stripe;

let cached: { key: string; account: string | null; promise: Promise<Stripe | null> } | null = null;

export function clearStripeMemo(): void {
  cached = null;
}

export function getStripe(
  publishableKey: string,
  stripeAccount: string | null,
): Promise<Stripe | null> {
  if (cached && cached.key === publishableKey && cached.account === stripeAccount) {
    return cached.promise;
  }
  const promise = loadStripe(publishableKey, stripeAccount ? { stripeAccount } : undefined);
  cached = { key: publishableKey, account: stripeAccount, promise };
  return promise;
}
